import { useMutation } from '@tanstack/react-query';
import { updateAlternative } from "@/api/alternative"; 
import { UpdateAlternativeRequest } from "@/types"; 
import { PostParam } from "@/types/index"; 

export function useUpdateAlternative(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<any, Error, UpdateAlternativeRequest>({
    mutationFn: updateAlternative,
    onSuccess,
    onError
  });
}